import React, {
  useContext,
  useState,
  useImperativeHandle,
  useCallback,
  useRef,
  useEffect,
  ReactComponentElement,
  createRef,
} from "react";
import type { MouseEvent } from "react";
import { MutableRefObject } from "react";

interface Props {
  url: string;
  className: string;
  imgClass: string;
}

const SlideOverview = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    url: slideOverviewUrl,
    className = "SlideOverview relative border-red-100 border",
    imgClass = "w-full max-w-md",
  } = props;

  return (
    <div ref={ref} className={className}>
      <img src={slideOverviewUrl} className={imgClass} />
    </div>
  );
});

export default SlideOverview;
